/**
 * Helpers para detectar y reemplazar variables en templates.
 * Sintaxis: {{nombre}}, {{monto}}, etc.
 */

const VAR_REGEX = /\{\{\s*([a-z_][a-z0-9_]*)\s*\}\}/gi;

export function detectVars(...texts: (string | null | undefined)[]): string[] {
  const all = texts.filter(Boolean).join(" ");
  const matches = all.match(VAR_REGEX) || [];
  return Array.from(new Set(matches.map((v) => v.replace(/[{}\s]/g, "").toLowerCase())));
}

export function renderTemplate(body: string, vars: Record<string, string | number | undefined | null>): string {
  return body.replace(VAR_REGEX, (_, key: string) => {
    const v = vars[key.toLowerCase()];
    return v == null ? `{{${key}}}` : String(v);
  });
}

/** Variables del Lead estándar disponibles para todas las plantillas. */
export const LEAD_VAR_LABELS: Record<string, string> = {
  nombre: "Nombre completo del lead",
  cedula: "Cédula / documento",
  telefono: "Teléfono",
  email: "Email",
  monto: "Monto aprobado (COP)",
  modelo: "Producto / modelo de celular",
  ciudad: "Ciudad",
  tienda: "Tienda aliada de origen",
  asesor: "Asesor que originó",
  fecha_aprob: "Fecha de aprobación",
  dias_caduca: "Días para que caduque el crédito",
  id: "ID del lead (para atribución, krd.lg/{{id}})",
};

export const ALL_LEAD_VARS = Object.keys(LEAD_VAR_LABELS);
